package org.example.project.client.error

sealed class ApiClientException(
    message: String
) : RuntimeException(message)

open class ApiHttpException(
    val statusCode: Int,
    val errorCode: String,
    val serverMessage: String,
    val requestId: String
) : ApiClientException("API HTTP error $statusCode ($errorCode) [req=$requestId]") {
    override fun toString(): String =
        "${this::class.simpleName}(statusCode=$statusCode, errorCode=$errorCode, requestId=$requestId)"
}

class ValidationException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId)

class UnauthorizedException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId)

class ForbiddenException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId)

class ConflictException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId)

class RateLimitedException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String,
    val retryAfterSeconds: Long?
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId) {
    override fun toString(): String =
        "RateLimitedException(statusCode=$statusCode, errorCode=$errorCode, requestId=$requestId, retryAfterSeconds=$retryAfterSeconds)"
}

class ServerErrorException(
    statusCode: Int,
    errorCode: String,
    serverMessage: String,
    requestId: String
) : ApiHttpException(statusCode, errorCode, serverMessage, requestId)

class NetworkException(
    message: String = "Network connection failure"
) : ApiClientException(message)

class RequestTimeoutException(
    message: String = "Request execution timed out"
) : ApiClientException(message)

class UnexpectedPayloadException(
    message: String = "Unexpected or malformed response payload"
) : ApiClientException(message)

class MissingCsrfTokenException(
    message: String = "Missing CSRF token for web mutation. Reauthentication required."
) : ApiClientException(message)

class SessionStorageException(
    message: String = "Storage operation failed"
) : ApiClientException(message)
